import { render, staticRenderFns } from "./partList.vue?vue&type=template&id=033e1976&scoped=true&"
import script from "./partList.vue?vue&type=script&lang=js&"
export * from "./partList.vue?vue&type=script&lang=js&"
import style0 from "./partList.vue?vue&type=style&index=0&id=033e1976&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033e1976",
  null
  
)

export default component.exports